export const UNABLE_TO_GET_USER_MESSAGE = 'Unable to get user';
export const RELOAD_PAGE_MESSAGE = 'Please, try to reload your page.';
export const CHANGE_PASSWORD_MESSAGE = 'Your password is expired. Please, check your email.';
export const DEFAULT_ERROR_MESSAGE = `We apologize for the inconvenience. ${RELOAD_PAGE_MESSAGE} If you continue experiencing an issue, please contact our support team.`;
function getErrorMessage(errorMessage) {
    switch (errorMessage?.toLowerCase()) {
        case 'password is expired':
            return CHANGE_PASSWORD_MESSAGE;
        default:
            return errorMessage
                ? `${errorMessage}. ${RELOAD_PAGE_MESSAGE}`
                : DEFAULT_ERROR_MESSAGE;
    }
}
export function isWithHomePageButton(errorMessage) {
    return [CHANGE_PASSWORD_MESSAGE].includes(errorMessage);
}
export default getErrorMessage;
//# sourceMappingURL=error-messages.js.map